export const formatNumber = (value: string | number, prefix = false, fractionDigits = 2): string => {
    if (!value && value !== 0) {
        return "";
    }
    return prefix
        ? Number(value).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
        : Number(value).toLocaleString('pt-BR', {
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits,
        });
};

export const transformCurrency = (value: number) => {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const transformNumber = (value: string) => {
    let numericValue = value.replace(/\D/g, '');
    return Number(numericValue) / 100;
};
